export default "__VITE_ASSET__ByC4D48p__"